export const vipBeelinePath = '/vip-beeline'
export const vipBeelineSubscriptionPath = `${vipBeelinePath}/:subscriptionId`

export interface VipBeelinePathParams {
  subscriptionId: string
}
